import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Result, pipeDataResult, toDataResult } from '@team23/ts-result';
import { AbstractMapIconsService } from '@ui/shared/domain-api';
import { BehaviorSubject, Observable, map, switchMap } from 'rxjs';
import { TooltipModule } from 'primeng/tooltip';
import { IconStatus } from '@ui/shared/util-api';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-map-item-icon',
    templateUrl: './map-item-icon.component.html',
    styleUrls: ['./map-item-icon.component.scss'],
    imports: [
        CommonModule,
        TooltipModule,
    ],
})
export class MapItemIconComponent {
    @Input({ required: true })
    public altText = '';

    public svg$: Observable<Result<SafeHtml, IconStatus>>;

    public iconPath$ = new BehaviorSubject<string>('');

    public readonly loadingStatus = IconStatus.Loading;

    constructor(
        private readonly _mapIconsService: AbstractMapIconsService,
        _domSanitizer: DomSanitizer,
    ) {
        this.svg$ = this.iconPath$
            .pipe(
                switchMap(iconPath => this._mapIconsService.mapIcon$(iconPath)),
                pipeDataResult(
                    map(result => _domSanitizer.bypassSecurityTrustHtml(result.data)),
                    toDataResult(),
                ),
            );
    }

    @Input({ required: true })
    public set iconPath(iconPath: string) {
        this.iconPath$.next(iconPath);
    }

    public reloadIcon(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        this._mapIconsService.addIconsFromPaths([this.iconPath$.value], { replaceExisting: true });
    }
}
